import classNames from 'classnames';
import { forwardRef } from 'react';
const accessListSectionsCss = "a1mjlsx7";
export const AccessListSectionsContainer = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(accessListSectionsCss, props.className)} />;
});
const accessListSectionCss = "abvjaax";
export const AccessListSectionContainer = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(accessListSectionCss, props.className)} />;
});
export const accessListSectionHeaderCss = "a18roh5w";
const accessListCss = "a1smbwj3";
export const AccessList = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'ul';
  return <Component ref={ref} {...restProps} className={classNames(accessListCss, props.className)} />;
});
const accessListItemCss = "a1o0kk5k";
export const AccessListItem = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'li';
  return <Component ref={ref} {...restProps} className={classNames(accessListItemCss, props.className)} />;
});
const accessListItemContentCss = "a10jce1p";
const accessListItemLeadingCss = "a1fi7u5h";
export const AccessListItemLeading = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(accessListItemLeadingCss, props.className)} />;
});
export const AccessListItemContent = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(accessListItemContentCss, props.className)} />;
});
const accessListItemTextCss = "apqflii";
export const accessListItemTextLineCss = "a6bclz9";
export const AccessListItemText = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(accessListItemTextCss, props.className)} />;
});
const groupIconContainerCss = "gpumqme";
export const GroupIconContainer = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(groupIconContainerCss, props.className)} />;
});
const organizationIconContainerCss = "o1cm1iye";
export const OrganizationIconContainer = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(organizationIconContainerCss, props.className)} />;
});
export const organizationListItemContentCss = "ohy6tmg";
const accessListItemActionCss = "a1el5qdh";
export const AccessListItemAction = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(accessListItemActionCss, props.className)} />;
});
export const permissionSelectReadOnlyLabelCss = "pllwiy3";

// Keep the menu shrink-wrapped; AccessListItemAction right-aligns within the action column.
export const permissionSelectMenuContainerCss = "pmc68hi";
export const permissionSelectTriggerButtonCss = "pshvoeq";

require("./styles.wyw-in-js.css!=!../../../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./styles.js");